<template>
  <div>
    <a-card style="margin: 20px">
      <template #title>
        <div class="top-title">
          <div class="left"><span>原始结算订单查询</span></div>
          <div class="right">
            <DepartmentChoose :department-code.sync="form.departmentCode"
                              @change="departmentIdchange"></DepartmentChoose>
          </div>
        </div>
      </template>

      <!-- 查询 -->
      <div class="formbox">
        <div class="inputbox">
          <div class="lefttitle">商户号</div>
          <MchChooseDialog v-model="form.mchName" @chooseDone="onMchChosenForQuery"></MchChooseDialog>
        </div>
        <div class="inputbox">
          <div class="lefttitle">店铺号</div>
          <ShopChooseDialog v-model="form.shopName" :mch-no="form.mchNo"
                            @chooseDone="onShopChosenForQuery"></ShopChooseDialog>
        </div>
        <div class="inputbox">
          <div class="lefttitle">汇总状态</div>
          <a-select v-model="form.summaryStatus" placeholder="请选择汇总状态" allowClear style="width: 200px">
            <a-select-option v-for="o in summaryStatusOptions" :key="o.value" :value="o.value">
              <a-tag :color="o.color">{{ o.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>
        <div class="inputbox">
          <div class="lefttitle">结算日期</div>
          <a-range-picker valueFormat="YYYY-MM-DD" v-model="dateRange"
                          @change="onDateChange" style="width: 240px"
                          placeholder="['开始日期','结束日期']" />
        </div>
        <a-button @click="search" type="primary">查询</a-button>
        <a-button @click="reset" class="reset">重置</a-button>
      </div>

      <!-- 工具栏 -->
      <div class="Toleadinto">
        <a-button-group>
          <a-button @click="goDetail" type="normal" icon="eye"
                    :disabled="selectedRows.length !== 1"
                    v-if="$authority('consignOriginalSettleOrderView')">查看详情</a-button>
        </a-button-group>
      </div>

      <!-- 表格 -->
      <div class="tablebox">
        <a-table size="small" :row-selection="{
            selectedRowKeys: selectedRowKeys,
            hideDefaultSelections: true,
            onChange: onSelectChange,
          }" :row-key="(record) => `${record.id}`" :columns="columns" :data-source="data"
                 :pagination="false">
        </a-table>
      </div>
      <lcfs-pagination :page-no.sync="pagination.pageNo" :page-size.sync="pagination.pageSize"
                       :total="total" :fn="getOrders"></lcfs-pagination>
    </a-card>

    <!-- 详情 弹框 -->
    <a-modal
        :visible="detailVisible"
        :width="'65%'"
        :style="{ height: '80%' }"
        :body-style="{ height: 'calc(100% - 110px)', padding: '16px', overflow: 'auto' }"
        :footer="null"
        :destroy-on-close="true"
        :mask-closable="true"
        :keyboard="true"
        :title="`原始结算订单详情 - ${detail.orderNo || ''}`"
        @cancel="detailVisible = false"
    >
      <a-spin :spinning="detailLoading">
        <!-- 1. 订单与主体 -->
        <a-descriptions title="订单与主体" :column="3" bordered size="small">
          <a-descriptions-item label="子订单号">
            <span class="text-mono"><b>{{ detail.orderNo || '----' }}</b></span>
          </a-descriptions-item>
          <a-descriptions-item label="主订单号">{{ detail.mainOrderNo || '----' }}</a-descriptions-item>
          <a-descriptions-item label="商品类型">{{ detail.goodsType || '----' }}</a-descriptions-item>
          <a-descriptions-item label="商户号">{{ detail.mchNo || '----' }}</a-descriptions-item>
          <a-descriptions-item label="商户名">{{ detail.mchName || '----' }}</a-descriptions-item>
          <a-descriptions-item label="店铺号">{{ detail.shopNo || '----' }}</a-descriptions-item>
          <a-descriptions-item label="店铺名" :span="3">{{ detail.shopName || '----' }}</a-descriptions-item>
        </a-descriptions>

        <!-- 2. 结算(金额突出) -->
        <a-descriptions title="结算" :column="3" bordered size="small">
          <a-descriptions-item label="结算日期">{{ detail.settleDate || '----' }}</a-descriptions-item>
          <a-descriptions-item label="结算时间">{{ detail.settleTime || '----' }}</a-descriptions-item>
          <a-descriptions-item label="结算金额" :span="3">
            <Balance class="amount-emphasis-lg" :amount="detail.settlementAmt || 0" dcflag="c" inline />
          </a-descriptions-item>
        </a-descriptions>

        <!-- 3. 汇总 -->
        <a-descriptions title="汇总" :column="3" bordered size="small">
          <a-descriptions-item label="汇总状态">
            <a-tag :color="summaryStatusColor(detail.summaryStatus)">
              {{ summaryStatusLabel(detail.summaryStatus) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="汇总日期">{{ detail.summaryDate || '----' }}</a-descriptions-item>
          <a-descriptions-item label="汇总时间">{{ detail.summaryTime || '----' }}</a-descriptions-item>
          <a-descriptions-item label="汇总单号" :span="3">
            <a v-if="detail.summaryNo" class="link-text"
               @click="onSummaryNoClick(detail.summaryNo)">{{ detail.summaryNo }}</a>
            <span v-else class="muted">未汇总</span>
          </a-descriptions-item>
        </a-descriptions>

        <!-- 4. 协议与系统 -->
        <a-descriptions title="协议与系统" :column="3" bordered size="small">
          <a-descriptions-item label="代销协议号" :span="3">
            <a v-if="detail.contractNo" class="link-text"
               @click="onContractNoClick(detail.contractNo)">{{ detail.contractNo }}</a>
            <span v-else class="muted">未关联</span>
          </a-descriptions-item>
          <a-descriptions-item label="部门ID">{{ detail.departmentId || '----' }}</a-descriptions-item>
          <a-descriptions-item label="部门编码">{{ detail.departmentCode || '----' }}</a-descriptions-item>
          <a-descriptions-item label="渠道号">{{ detail.channelNo || '----' }}</a-descriptions-item>
          <a-descriptions-item label="应用号">{{ detail.appNo || '----' }}</a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ detail.createTime || '----' }}</a-descriptions-item>
          <a-descriptions-item label="更新时间">{{ detail.updateTime || '----' }}</a-descriptions-item>
        </a-descriptions>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import Balance from '@/view/components/Balance.vue'
import DepartmentChoose from '@/view/components/DepartmentChoose.vue'
import LcfsPagination from '@/view/components/LcfsPagination.vue'
import MchChooseDialog from '@/view/components/ChooseDialog/MchChooseDialog.vue'
import ShopChooseDialog from '@/view/components/ChooseDialog/ShopChooseDialog.vue'
import { summaryStatusConfig, toOptions } from '@/utils/bizDict/consignDict'

export default {
  name: 'ConsignOriginalSettleOrderList',
  components: { LcfsPagination, DepartmentChoose, Balance, MchChooseDialog, ShopChooseDialog },
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      total: 0,
      data: [],
      pagination: { pageNo: 1, pageSize: 10 },
      form: {
        mchNo: '',
        mchName: '',
        shopNo: '',
        shopName: '',
        summaryStatus: undefined,
        departmentCode: '',
        settleDateStart: '',
        settleDateEnd: '',
      },
      dateRange: [],
      summaryStatusOptions: toOptions(summaryStatusConfig),

      // 详情
      detailVisible: false,
      detailLoading: false,
      detail: {},
    }
  },
  computed: {
    singleSelected() { return this.selectedRows.length === 1 },
    selected() { return this.singleSelected ? this.selectedRows[0] : null },
    columns() {
      return [
        {
          title: 'No',
          customRender: (text, record, index) =>
            `${Number(this.pagination.pageNo - 1) * Number(this.pagination.pageSize) + Number(index + 1)}`,
          width: 60,
        },
        { title: '子订单号', dataIndex: 'orderNo', width: 200 },
        { title: '主订单号', dataIndex: 'mainOrderNo', width: 180 },
        { title: '商户号', dataIndex: 'mchNo', width: 120 },
        { title: '店铺号', dataIndex: 'shopNo', width: 150 },
        { title: '结算日期', dataIndex: 'settleDate', width: 110 },
        { title: '结算金额', dataIndex: 'settlementAmt', width: 130,
          customRender: (t) => <Balance amount={t} dcflag="c" /> },
        { title: '代销协议号', dataIndex: 'contractNo', width: 160,
          customRender: (t) => t
            ? <span style="color:#333">{t}</span>
            : <span style="color:#999">未关联</span> },
        { title: '汇总状态', dataIndex: 'summaryStatus', width: 100,
          customRender: (t) => {
            const c = summaryStatusConfig[t] || summaryStatusConfig.default
            return <a-tag color={c.color}>{c.label}</a-tag>
          } },
        { title: '汇总单号', dataIndex: 'summaryNo', width: 200,
          customRender: (t) => t
            ? <span style="color:#1890ff">{t}</span>
            : <span style="color:#999">未汇总</span> },
        { title: '汇总时间', dataIndex: 'summaryTime', width: 160 },
        { title: '创建时间', dataIndex: 'createTime', width: 160 },
      ]
    },
  },
  methods: {
    departmentIdchange(v) { this.form.departmentCode = v },
    onDateChange(dates) {
      if (dates && dates.length === 2) {
        this.form.settleDateStart = dates[0]
        this.form.settleDateEnd = dates[1]
      } else {
        this.form.settleDateStart = ''
        this.form.settleDateEnd = ''
      }
    },
    onSelectChange(keys, rows) {
      this.selectedRowKeys = keys
      this.selectedRows = rows
    },
    async getOrders() {
      const req = { ...this.form, ...this.pagination }
      const res = await this.api.originalSettleOrderPageApi(req)
      if (res.code !== 200) {
        this.$message.error(res.info || '查询失败')
        return
      }
      this.total = res.data.total
      this.data = res.data.records || []
    },
    search() { this.pagination.pageNo = 1; this.getOrders() },
    reset() {
      Object.assign(this.form, {
        mchNo: '', mchName: '', shopNo: '', shopName: '', summaryStatus: undefined,
        settleDateStart: '', settleDateEnd: '',
      })
      this.dateRange = []
      this.search()
    },

    async goDetail() {
      const orderNo = this.selected.orderNo
      this.detailLoading = true
      this.detailVisible = true
      try {
        const res = await this.api.originalSettleOrderDetailApi(orderNo)
        if (res.code !== 200) {
          this.$message.error(res.info || '查询详情失败')
          this.detailVisible = false
          return
        }
        this.detail = res.data || {}
      } finally {
        this.detailLoading = false
      }
    },

    onSummaryNoClick(summaryNo) {
      this.$message.info(`汇总单号 ${summaryNo}:请到[汇总单管理]菜单查看详情`)
    },
    onContractNoClick(contractNo) {
      this.$router.push({ path: '/consign/contract/detail', query: { contractNo } })
    },

    // 搜索表单 — 商户/店铺选择
    onMchChosenForQuery(mch) {
      this.form.mchNo = mch.mchNo
      this.form.mchName = mch.mchName
    },
    onShopChosenForQuery(shop) {
      this.form.shopNo = shop.shopNo
      this.form.shopName = shop.shopName
    },

    summaryStatusColor(s) { return (summaryStatusConfig[s] || summaryStatusConfig.default).color },
    summaryStatusLabel(s) { return (summaryStatusConfig[s] || summaryStatusConfig.default).label },
  },
  mounted() {
    Object.assign(this.form, this.$route.query)
    this.getOrders()
  },
}
</script>

<style scoped>
.top-title { display: flex; justify-content: space-between; align-items: center; }
.top-title .left span { font-weight: 600; }
.formbox { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; padding: 12px 0; }
.inputbox { display: flex; align-items: center; gap: 8px; }
.lefttitle { width: 80px; color: #666; }
.Toleadinto { margin: 12px 0; }
.tablebox { margin-top: 8px; }
.reset { margin-left: 8px; }

/* 详情弹框样式 */
.text-mono {
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  font-size: 12px;
}
.link-text {
  color: #1890ff;
  cursor: pointer;
  text-decoration: none;
}
.link-text:hover {
  text-decoration: underline;
}
.muted {
  color: #999;
}
/* 结算金额突出:整行 span=3,字号略大 + 加粗 */
.amount-emphasis-lg .balance {
  font-weight: 700;
  font-size: 18px;
}
/* 详情弹框:每个 Descriptions 之间留 12px */
>>> .ant-descriptions {
  margin-bottom: 12px;
}
>>> .ant-descriptions:last-child {
  margin-bottom: 0;
}
</style>
